import { gql } from '@apollo/client';

export const UPDATE_OBJECTS_MUTATION = gql`
  mutation UpdateObjectsMutation(
    $ids: [String!]!
    $object: BatchObjectInput!
  ) {
    updateObjects(ids: $ids, object: $object) {
      ... on UpdateObjectsSuccess {
        objects {
          id
          createdAt
          updatedAt
          createdBy
          createdByName
          createdByEmail
          name
          description
          position
          geometry
          type
          siteId
          siteStatus
          groupId
          parentId
          parentName
          mapsVisible
          filled
          visibility
        }
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
